import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import {
    NavLink
} from "react-router-dom";

class TopMenuComponent extends Component{
    static contextType = AuthContext;
    render(){
        return (
            <ul className="top_menu">
                <li><NavLink exact to={`${process.env.PUBLIC_URL}/`}>Home</NavLink></li>
                <li>
                    {this.context.authenticated ?
                        <NavLink exact
                                 to={`${process.env.PUBLIC_URL}/profile`}>Profile</NavLink>
                        :
                        <NavLink exact
                                 to={`${process.env.PUBLIC_URL}/login`}>Login</NavLink>
                    }
                </li>
                <li><NavLink exact to={`${process.env.PUBLIC_URL}/search`}>Search</NavLink></li>
            </ul>
        );
    }
}

export default TopMenuComponent;